import { render, staticRenderFns } from "./CameraPermission.vue?vue&type=template&id=71fc24c0&scoped=true&"
import script from "./CameraPermission.vue?vue&type=script&lang=js&"
export * from "./CameraPermission.vue?vue&type=script&lang=js&"
import style0 from "./CameraPermission.vue?vue&type=style&index=0&id=71fc24c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fc24c0",
  null
  
)

export default component.exports